import { cn } from "@/lib/cn";
import { useLocation } from "@tanstack/react-router";
import { ManualFormHash } from "../-constants/constant";
import { Step1Form } from "./Step1Form";
import { Step2Form } from "./Step2Form";

type Props = {
  className?: string;
};

export function NetworkForm({ className }: Props) {
  const location = useLocation();
  const hash = location.hash.replace("#", "");

  const renderForm = () => {
    switch (hash) {
      case ManualFormHash.accessControl:
        return <Step2Form />;
      case ManualFormHash.networkInformation:
      case "":
      default:
        return <Step1Form />;
    }
  };

  return <div className={cn("pb-24", className)}>{renderForm()}</div>;
}
